import OpenInNew from "@mui/icons-material/OpenInNew";
import { Box, Button, Paper, Stack, Typography, useTheme } from "@mui/material";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { Link as RouterLink } from "react-router-dom";
import { useCohortDetails } from "./useCohortDetails";

export function RelatedCohortsCard() {
  const theme = useTheme();
  const { data } = useCohortDetails();

  const cohort = data?.cohort;
  const relatedCohorts = cohort?.relatedCohorts ?? [];

  if (!cohort || relatedCohorts.length === 0) {
    return null;
  }

  return (
    <Paper
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 1,
        p: 2,
      }}
      elevation={0}
    >
      <Typography
        variant="h6"
        fontWeight="600"
        sx={{ mb: 1.5, color: theme.palette.text.primary }}
      >
        Related Cohorts
      </Typography>

      <Stack spacing={1.5}>
        {relatedCohorts.map((relatedCohort) => {
          const totalCount = relatedCohort.totalMemberCount ?? 0;
          const workflowStatus = relatedCohort.workflowStatus
            ? prettyPrintEnumValue(relatedCohort.workflowStatus)
            : "No workflow";

          return (
            <Box
              key={relatedCohort.id}
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                p: 1.5,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: 2,
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Box>
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    sx={{ color: theme.palette.text.primary }}
                  >
                    Members {totalCount}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Status {prettyPrintEnumValue(relatedCohort.status)} • Workflow{" "}
                    {workflowStatus}
                  </Typography>
                </Box>
                <Button
                  variant="outlined"
                  size="small"
                  component={RouterLink}
                  to={`/staff/cohorts/${relatedCohort.id}/activities`}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ whiteSpace: "nowrap" }}
                  endIcon={<OpenInNew fontSize="small" />}
                >
                  View cohort
                </Button>
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
}
